import PersonSilhouette from '../atoms/PersonSilhouette/PersonSilhouette';

const ChildIndicator = ({ children, student = null, setter = null }) => {
  const handleClick = () => {
    if (setter != null) setter(student);
  };
  return (
    <div className='' onClick={handleClick} data-cy={`child-${children}`}>
      <PersonSilhouette />
      {children}
    </div>
  );
};

export default ChildIndicator;
